export const englishBadWords = ['anal','anus','arse','ass','ass fuck','ass hole','assfucker','asshole','assshole','bastard','bitch','black cock','bloody hell','boong','cock','cockfucker','cocksuck','cocksucker','coon','coonnass','crap','cunt','cyberfuck','damn','darn','dick','dirty','douche','dummy','erect','erection','erotic','escort','fag','faggot','fuck','Fuck off','fuck you','fuckass','fuckhole','god damn','gook','hard core','hardcore','homoerotic','hore','lesbian','lesbians','mother fucker','motherfuck','motherfucker','negro','nigger','orgasim','orgasm','penis','penisfucker','piss','piss off','porn','porno','pornography','pussy','retard','sadist','sex','sexy','shit','slut,son of a bitch','suck','tits','viagra','whore','xxx']


export class ValidateScreenName {

  constructor() {
    this.englishBadWordsRegEx =  englishBadWords.map(word => {
      return new RegExp(word, "gi")
    })

    this.nameValidatorRegex = new RegExp(/^(?=.{3,25}$)(?:[a-zA-Z\d]+(?:(?:\.|-|_)[a-zA-Z\d])*)+$/);
  }

  hasBadWordEng (str) {
    this.englishBadWordsRegEx.forEach((rgx) => {
      if(rgx.test(str)){
        console.log( str, " has: ", rgx.toString())
        return true
      }
    })
    return false;
  }

  validateScreenName(str) {
    return this.nameValidatorRegex.test(str);
  }
}